module.exports = __webpack_public_path__ + "static/img/slide-1-image@3x.7599ac8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo/slide-1-image@3x.jpg
// module id = zJiy
// module chunks = 6